/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PhotoDetails_tradePhoto = {
    readonly name: string | null;
    readonly caption: string | null;
    readonly styles: ReadonlyArray<{
        readonly name: string | null;
        readonly urlLabel: string | null;
    } | null> | null;
    readonly room: {
        readonly name: string | null;
        readonly urlLabel: string | null;
    } | null;
    readonly " $refType": "PhotoDetails_tradePhoto";
};
export type PhotoDetails_tradePhoto$data = PhotoDetails_tradePhoto;
export type PhotoDetails_tradePhoto$key = {
    readonly " $data"?: PhotoDetails_tradePhoto$data;
    readonly " $fragmentRefs": FragmentRefs<"PhotoDetails_tradePhoto">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "urlLabel",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "PhotoDetails_tradePhoto",
  "type": "TradePhoto",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "caption",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "styles",
      "storageKey": null,
      "args": null,
      "concreteType": "TradePhotoStyle",
      "plural": true,
      "selections": (v1/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "room",
      "storageKey": null,
      "args": null,
      "concreteType": "TradePhotoStyle",
      "plural": false,
      "selections": (v1/*: any*/)
    }
  ]
};
})();
(node as any).hash = 'afbd1dfb164c3c21c2fd2ba3a9e2f42e';
export default node;
